/**
 * @deprecated
 * use MultiChoiceWithText
 */
import React from 'react';
import MultiChoiceQuestionEditor, { Props as EditorProps } from './MultiChoiceQuestionEditor';
import MultiChoiceQuestionInput, { Props as InputProps } from './MultiChoiceQuestionInput';

type EditProps = EditorProps & {
  mode: 'edit';
}

type ViewProps = Pick<InputProps, 'question'> & {
  mode: 'view';
  deprecated?: boolean;
};

type SubmitProps = InputProps & {
  mode: 'submit';
}

type Props = EditProps | ViewProps | SubmitProps;

const MultiChoiceQuestion: React.FC<Props> = (props: Props) => {
  const { mode } = props;

  if (mode === 'edit') {
    const {
      surveyId,
      sectionId,
      addQuestion,
      question,
      onCancelEdit,
      updateQuestion,
      disableHideAggregation,
    } = props as EditProps;
    return (
      <MultiChoiceQuestionEditor
        surveyId={surveyId}
        sectionId={sectionId}
        question={question}
        addQuestion={addQuestion}
        updateQuestion={updateQuestion}
        onCancelEdit={onCancelEdit}
        disableHideAggregation={disableHideAggregation}
      />
    );
  }

  if (mode === 'view') {
    const {
      question,
      deprecated,
    } = props as ViewProps;
    return (
      <MultiChoiceQuestionInput
        deprecated={deprecated}
        question={question}
        disabled={false}
      />
    );
  }

  if (mode === 'submit') {
    const {
      caseId,
      sectionId,
      enrollmentId,
      disabled,
      defaultSubmission,
      question,
      summarizedView,
      onSave,
    } = props as SubmitProps;
    return (
      <MultiChoiceQuestionInput
        question={question}
        caseId={caseId}
        sectionId={sectionId}
        enrollmentId={enrollmentId}
        disabled={disabled}
        onSave={onSave}
        defaultSubmission={defaultSubmission}
        summarizedView={summarizedView}
      />
    );
  }

  return null;
};

export default MultiChoiceQuestion;
